export const categories = [
  { slug: 'wanghong-fanche', name: '网红翻车', icon: 'ri-emotion-sad-line', description: '网红翻车现场实拍合集' },
  { slug: 'mingxing-bagua', name: '明星八卦', icon: 'ri-star-line', description: '明星八卦内幕独家爆料' },
  { slug: 'remen-baoliao', name: '热门爆料', icon: 'ri-fire-line', description: '最新最热吃瓜爆料视频' },
  { slug: 'fancha-shipin', name: '反差视频', icon: 'ri-contrast-2-line', description: '人前人后反差巨大现场' },
];

export const videos = [
  {
    id: 1,
    title: '某千万粉丝网红直播翻车全程实录',
    description: '某知名带货主播直播间翻车，口误说出品牌底价引发品牌方当场翻脸。全程高能无尿点，千万粉丝网红人设崩塌现场。网友：这波吃瓜太刺激了！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Blurred%20modern%20live%20streaming%20studio%20with%20dramatic%20warm%20amber%20lighting%2C%20abstract%20geometric%20shapes%20in%20background%2C%20cinematic%20atmosphere%2C%20professional%20product%20photography%20style%20with%20soft%20shadows%2C%20warm%20dark%20tones%2C%20editorial%20quality&width=800&height=500&seq=video-thumb-01&orientation=landscape',
    duration: '12:34',
    views: 2380000,
    category: 'wanghong-fanche',
    date: '2026-06-27',
    featured: true,
    tags: ['直播翻车', '带货翻车', '千万网红'],
    source: '网友爆料',
  },
  {
    id: 2,
    title: '顶流明星深夜密会神秘女子，狗仔全程跟拍',
    description: '娱乐圈再爆重磅八卦！当红顶流小生深夜与神秘女子共进晚餐后同返公寓，狗仔蹲守三天三夜拍下独家画面。女方身份引发全网猜测。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20city%20night%20street%20scene%20with%20warm%20street%20lamp%20glow%2C%20abstract%20silhouette%20figures%2C%20cinematic%20noir%20style%2C%20moody%20atmosphere%2C%20soft%20focus%20background%2C%20editorial%20photography%2C%20deep%20shadows%20with%20amber%20highlights&width=800&height=500&seq=video-thumb-02&orientation=landscape',
    duration: '08:21',
    views: 5670000,
    category: 'mingxing-bagua',
    date: '2026-06-26',
    featured: true,
    tags: ['顶流明星', '深夜约会', '狗仔爆料'],
    source: '娱乐狗仔队',
  },
  {
    id: 3,
    title: '知名企业家私密录音曝光，内容令人震惊',
    description: '一段疑似某知名企业家的私密录音在网络疯传，录音内容涉及商业内幕和个人隐私，引发全网热议。当事方暂未回应。吃瓜群众：这瓜保熟！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Minimalist%20modern%20office%20interior%20with%20warm%20ambient%20lighting%2C%20abstract%20corporate%20atmosphere%2C%20soft%20shadows%20on%20walls%2C%20professional%20editorial%20style%2C%20clean%20composition%2C%20warm%20neutral%20tones&width=800&height=500&seq=video-thumb-03&orientation=landscape',
    duration: '15:42',
    views: 4120000,
    category: 'remen-baoliao',
    date: '2026-06-25',
    featured: true,
    tags: ['私密录音', '企业家', '内幕爆料'],
    source: '知情人士',
  },
  {
    id: 4,
    title: '清纯女星夜店热舞视频流出，人设彻底崩塌',
    description: '以清纯人设走红的女星被曝夜店热舞视频，与平日形象反差巨大。网友纷纷感叹：这反差也太大了吧！人设崩塌来得猝不及防。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Abstract%20nightclub%20atmosphere%20with%20colorful%20ambient%20lights%2C%20blurred%20dance%20floor%2C%20warm%20red%20and%20amber%20tones%2C%20cinematic%20moody%20lighting%2C%20soft%20focus%2C%20editorial%20style%2C%20artistic%20composition&width=800&height=500&seq=video-thumb-04&orientation=landscape',
    duration: '06:18',
    views: 7890000,
    category: 'fancha-shipin',
    date: '2026-06-24',
    featured: false,
    tags: ['人设崩塌', '反差视频', '夜店热舞'],
    source: '匿名投稿',
  },
  {
    id: 5,
    title: '某选秀冠军被曝学历造假，回应来了',
    description: '选秀出道的冠军选手被网友扒出学历造假证据，连夜发长文回应却越描越黑。粉丝集体脱粉，品牌方紧急解约。这波翻车太彻底了！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20stage%20with%20spotlight%20and%20dramatic%20shadows%2C%20abstract%20performance%20atmosphere%2C%20warm%20golden%20accent%20lighting%2C%20cinematic%20composition%2C%20soft%20focus%20background%2C%20editorial%20quality&width=800&height=500&seq=video-thumb-05&orientation=landscape',
    duration: '10:55',
    views: 3450000,
    category: 'wanghong-fanche',
    date: '2026-06-23',
    featured: false,
    tags: ['学历造假', '选秀冠军', '品牌解约'],
    source: '网友深扒',
  },
  {
    id: 6,
    title: '娱乐圈模范夫妻被曝已分居半年',
    description: '曾被誉为娱乐圈模范夫妻的两位明星被知情人士爆料已分居半年，各自住在不同城市。回顾两人过往恩爱瞬间，如今只剩唏嘘。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20living%20room%20interior%20with%20warm%20soft%20lighting%2C%20abstract%20emotional%20atmosphere%2C%20split%20composition%20suggesting%20separation%2C%20cinematic%20style%2C%20warm%20amber%20and%20neutral%20tones%2C%20editorial%20photography&width=800&height=500&seq=video-thumb-06&orientation=landscape',
    duration: '09:47',
    views: 5210000,
    category: 'mingxing-bagua',
    date: '2026-06-22',
    featured: false,
    tags: ['模范夫妻', '分居', '婚姻危机'],
    source: '圈内人士',
  },
  {
    id: 7,
    title: '网红餐厅后厨卫生状况触目惊心',
    description: '某网红打卡餐厅后厨被离职员工曝光，画面触目惊心。老鼠横行、食材过期、卫生堪忧。此前该餐厅曾因排队三小时而登上热搜。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Abstract%20commercial%20kitchen%20interior%20with%20dramatic%20contrast%20lighting%2C%20warm%20and%20cool%20tone%20mix%2C%20cinematic%20atmosphere%2C%20soft%20shadows%2C%20editorial%20style%2C%20professional%20composition&width=800&height=500&seq=video-thumb-07&orientation=landscape',
    duration: '07:33',
    views: 6340000,
    category: 'remen-baoliao',
    date: '2026-06-21',
    featured: false,
    tags: ['网红餐厅', '卫生问题', '后厨曝光'],
    source: '离职员工',
  },
  {
    id: 8,
    title: '富二代聚会视频意外曝光奢华生活',
    description: '某富二代私人聚会视频意外流出，豪车名表奢侈品遍地，派对场面堪比电影。网友：贫穷限制了我的想象！但背后资金来源引发质疑。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Luxurious%20party%20venue%20with%20warm%20golden%20ambient%20lighting%2C%20abstract%20elegant%20atmosphere%2C%20soft%20focus%20background%2C%20cinematic%20composition%2C%20warm%20rich%20tones%2C%20editorial%20style%2C%20professional%20photography&width=800&height=500&seq=video-thumb-08&orientation=landscape',
    duration: '11:20',
    views: 4560000,
    category: 'fancha-shipin',
    date: '2026-06-20',
    featured: false,
    tags: ['富二代', '奢华生活', '反差视频'],
    source: '派对参与者',
  },
  {
    id: 9,
    title: '知名博主被指抄袭，原创作者发声维权',
    description: '百万粉丝博主被扒出多篇内容抄袭小透明创作者，原创作者忍无可忍公开发声维权。粉丝态度两极分化，评论区彻底沦陷。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Minimalist%20modern%20workspace%20with%20laptop%20and%20warm%20ambient%20light%2C%20creative%20atmosphere%2C%20soft%20shadows%2C%20editorial%20style%2C%20clean%20composition%2C%20warm%20neutral%20tones&width=800&height=500&seq=video-thumb-09&orientation=landscape',
    duration: '08:45',
    views: 2890000,
    category: 'wanghong-fanche',
    date: '2026-06-19',
    featured: false,
    tags: ['抄袭', '原创维权', '博主翻车'],
    source: '原创作者',
  },
  {
    id: 10,
    title: '某流量小生片场耍大牌视频遭曝光',
    description: '剧组工作人员匿名曝光某流量小生在片场耍大牌全过程：迟到三小时、对工作人员大吼大叫、要求特殊待遇。导演当场发飙的画面太精彩！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Film%20set%20atmosphere%20with%20dramatic%20lighting%2C%20warm%20cinematic%20tones%2C%20abstract%20behind%20the%20scenes%20vibe%2C%20soft%20focus%20background%2C%20editorial%20style%2C%20professional%20composition&width=800&height=500&seq=video-thumb-10&orientation=landscape',
    duration: '05:52',
    views: 3670000,
    category: 'mingxing-bagua',
    date: '2026-06-18',
    featured: false,
    tags: ['耍大牌', '流量小生', '片场风波'],
    source: '剧组工作人员',
  },
  {
    id: 11,
    title: '某科技公司CEO私人飞机炫富引争议',
    description: '某科技创业公司CEO在社交媒体晒私人飞机照片引发巨大争议，此前该公司刚进行大规模裁员。网友痛批：拿着投资人的钱挥霍无度！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Private%20jet%20interior%20with%20luxurious%20warm%20lighting%2C%20abstract%20wealthy%20lifestyle%20atmosphere%2C%20soft%20golden%20tones%2C%20cinematic%20composition%2C%20editorial%20style%2C%20professional%20photography&width=800&height=500&seq=video-thumb-11&orientation=landscape',
    duration: '04:38',
    views: 5120000,
    category: 'remen-baoliao',
    date: '2026-06-17',
    featured: false,
    tags: ['CEO炫富', '私人飞机', '裁员争议'],
    source: '社交平台',
  },
  {
    id: 12,
    title: '选美冠军素颜照流出，颜值反差惊呆网友',
    description: '某选美比赛冠军素颜生活照被好友意外流出，与舞台上精致妆容形成巨大反差。网友评论两极分化，有人力挺也有人嘲讽。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Two%20contrasting%20portrait%20styles%20in%20one%20frame%2C%20warm%20soft%20lighting%2C%20abstract%20duality%20theme%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20professional%20composition%2C%20neutral%20warm%20tones&width=800&height=500&seq=video-thumb-12&orientation=landscape',
    duration: '06:14',
    views: 6780000,
    category: 'fancha-shipin',
    date: '2026-06-16',
    featured: false,
    tags: ['素颜照', '选美冠军', '颜值反差'],
    source: '好友流出',
  },
];

export const featuredCollections = [
  {
    id: 1,
    title: '网红翻车合集',
    description: '盘点近期最惨网红翻车现场',
    count: 128,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20collapse%20concept%20with%20warm%20amber%20and%20coral%20gradient%2C%20geometric%20shapes%20scattered%2C%20cinematic%20atmosphere%2C%20soft%20focus%2C%20editorial%20style%2C%20modern%20art%20composition&width=600&height=400&seq=collection-01&orientation=landscape',
  },
  {
    id: 2,
    title: '娱乐圈大瓜汇总',
    description: '2026上半年最劲爆八卦合集',
    count: 96,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20entertainment%20news%20collage%20concept%2C%20warm%20golden%20and%20amber%20tones%2C%20overlapping%20geometric%20shapes%2C%20cinematic%20style%2C%20soft%20focus%2C%20editorial%20composition&width=600&height=400&seq=collection-02&orientation=landscape',
  },
  {
    id: 3,
    title: '年度反差视频精选',
    description: '人前人后反差最大的TOP50',
    count: 85,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20duality%20concept%20with%20split%20composition%2C%20warm%20and%20cool%20tone%20contrast%2C%20geometric%20shapes%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20modern%20art&width=600&height=400&seq=collection-03&orientation=landscape',
  },
];